<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Asesor Técnico</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-sm-12 card-wrapper">
          <!-- datos del zonal -->
          <seller-data :seller="seller"></seller-data>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 card-wrapper">
          <!-- distribuidores -->
          <distributors-list :seller="seller.id" />
        </div>
      </div>

      <div v-if="$can('index', 'visits')" class="row">
        <div class="col-sm-12 card-wrapper">
          <div class="card mb-4">
            <visits-table :custom-params="params" :show-author-filter="false" :title="title">
              <template slot="actions">
                <router-link
                  v-if="$can('store', 'visits')"
                  :to="{ name: 'SellerCreateVisit', params: { id: seller.id } }"
                  class="btn btn-outline-success btn-sm"
                >
                  <i class="fas fa-calendar"></i>&nbsp;Nueva Visita
                </router-link>
              </template>
            </visits-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import SellerData from './Show/SellerData';
import DistributorsList from './Show/DistributorsList';
import VisitsTable from '@/views/Visits/List/VisitsTable';
import ResetTableFilterMixin from '@/mixins/resetTableFilterMixin';

export default {
  name: 'SellersShow',
  components: {
    RouteBreadCrumb,
    SellerData,
    DistributorsList,
    VisitsTable,
  },

  mixins: [ResetTableFilterMixin],
  data() {
    return {
      seller: {},
      params: [],
      isDataLoaded: false,
      title: 'Visitas del asesor técnico',
    };
  },

  computed: {},
  created() {
    this.mixSaveTableCurrentFilters('visit');

    const sellerId = this.$route.params.id;
    this.fetchSeller(sellerId);
    this.params.push({ prop: 'filter[seller]', value: sellerId });
  },

  beforeDestroy() {
    this.mixRetrieveTablePreviousFilters('visit');
  },

  methods: {
    fetchSeller(sellerId) {
      const params = {
        append: ['last-visit-date', 'distributors-visits-count'],
        include: ['distributors', 'city.province', 'visitsCount'],
      };

      this.$services
        .resource('sellers')
        .show(sellerId, params)
        .then((res) => res.data.data)
        .then((seller) => {
          this.seller = seller;
          this.isDataLoaded = true;
          this.title = `Visitas de ${seller.name}`;
        });
    },
  },
};
</script>
